import React, {useState} from 'react';
import './styles.scss';
import * as fonts from '../../../util/fonts';
import {strings} from '../../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {setWizard} from '../../../store/actions';
import {Row} from '../../../components/layout';
import Bubble from '../bubble';
import AuthorizedImage from '../../../components/images';

// ir buscar strings ao BO
const labels = strings.pt.services;

interface MyServicesProps {
  user: any;
  titular: any;
  selectedBu: any;
  availableBus: any;
  wizard: any;
  buStyles: any;
  setWizard(value: any): void;
  labels: typeof strings.pt.services;
  maxItems?: any;
  hideList?: boolean;
  services: any;
  setShowError?(value: any): void;
  setShow?(value: any): void;
  retrieveServiceDetails?(value: any, isMedicoOnline: boolean): void;
}

function MyServices({
  selectedBu,
  labels,
  buStyles,
  setWizard,
  maxItems = 4,
  hideList,
  services,
  setShowError = () => {},
  setShow = () => {},
  retrieveServiceDetails = () => {},
}: MyServicesProps) {
  return (
    <>
      <Row className="my-services-row-images-container-responsive">
        {services &&
          services.length !== 0 &&
          Object.keys(services).map((key: any) => {
            if (
              services[key]?.isDigitalService ||
              services[key]?.isMedicoOnline
            )
              return (
                <Row
                  className="my-services-row-responsive"
                  onClick={() => {
                    retrieveServiceDetails(
                      services[key].serviceId,
                      services[key]?.isMedicoOnline
                    );
                    setShow(true);
                  }}>
                  <Row className="my-services-row-images-display-responsive">
                    <Bubble
                      classNames={'my-services-bubble-image-responsive'}
                    />
                    <AuthorizedImage
                      source={`${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL}${services[key].image}`}
                      className="my-services-images-responsive"
                    />
                  </Row>
                  <Row className="my-services-service-info-responsive">
                    <p
                      style={{
                        ...fonts.Bold,
                        ...fonts.L,
                        color: buStyles?.primaryColor,
                      }}
                      className="my-services-service-info-p-responsive">
                      {services[key].serviceName}
                    </p>
                    <p
                      style={{...fonts.M}}
                      className="my-services-service-info-p-description-responsive">
                      {services[key].listDescription}
                    </p>
                  </Row>
                </Row>
              );
          })}
        {services && services.length === 0 && (
          <Row className="my-services-more-services-available-title-responsive">
            <p style={{...fonts.M}}>{labels?.services_noServicesAvailable}</p>
          </Row>
        )}
        {services && !hideList && (
          <Row className="my-services-more-services-available-container-responsive">
            <Row className="my-services-more-services-available-title-responsive">
              <p
                style={{...fonts.M}}
                className="my-services-more-services-available-p-responsive">
                {labels?.services_subTitle}
              </p>
            </Row>

            {Object.keys(services).map((key: any) => {
              if (
                !services[key]?.isDigitalService &&
                !services[key]?.isMedicoOnline
              )
                return (
                  <Row className="my-services-more-services-available-list-container-responsive">
                    <Row
                      className="my-services-more-services-available-list-responsive"
                      onClick={() => {
                        retrieveServiceDetails(
                          services[key].serviceId,
                          services[key]?.isMedicoOnline
                        );
                        setShow(true);
                      }}>
                      <p
                        style={{
                          ...fonts.Bold,
                          ...fonts.MM,
                          color: buStyles?.primaryColor,
                        }}
                        className="my-services-service-info-p-responsive">
                        {services[key].serviceName}
                      </p>
                      <p
                        style={{...fonts.M}}
                        className="my-services-service-info-p-responsive">
                        {services[key].listDescription}
                      </p>
                    </Row>
                  </Row>
                );
            })}
          </Row>
        )}
      </Row>
    </>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  wizard,
  availableBus,
  globalStyles,
  titular,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  availableBus: availableBus.value,
  labels: strings.value.pt.services,
  wizard: wizard.value,
  buStyles: globalStyles.value,
  titular: titular.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(MyServices)
);
